export default {"src":"/_next/static/media/logo_1.f16c5b08.svg","height":54,"width":51,"blurWidth":0,"blurHeight":0};